<!--<mat-sidenav-container fullscreen  *ngIf="displayNav">-->

<!--    <mat-sidenav #sidenav role="navigation" mode= 'over' position="end">-->
<!--      <app-sidenav></app-sidenav>-->
<!--    </mat-sidenav>-->


<!--    <mat-sidenav-content >-->
<!--        <app-navbar fxHide fxShow.lt-sm *ngIf="displayNav"></app-navbar>-->
<!--        <main class="container-fluid mat-app-background" style="margin-bottom: 65px;">-->
<!--            <router-outlet></router-outlet>-->
<!--        </main>-->
<!--        <app-footer *ngIf="displayNav" class="sticky-bottom" (sidenavToggle)="sidenav.toggle()">-->
<!--        </app-footer>-->
<!--    </mat-sidenav-content>-->
<!--  </mat-sidenav-container>-->
<div class="light-mode">
  <router-outlet></router-outlet>
</div>

